import BeautyPass from '@/modules/api/beauty-pass'
import heroWeb from '../../assets/images/account/beauty_pass/hero_web.jpg'
import heroMobile from '../../assets/images/account/beauty_pass/hero_mobile.jpg'

const beautyPassApi = new BeautyPass()

const state = {
  pageLoaded: false,
  country: {},
  bannerImageUrl: heroWeb,
  bannerImageMobileWebUrl: heroMobile,
  points: [],
  membership: [],
  faqs: [],
  rewardsTitle: '',
  rewardsDescription: '',
  giftsTitle: '',
  giftsDescription: '',
  pointsTitle: '',
  pointsDescription: '',
  giftsBirthdayImageUrl: '',
  giftsTierUpgradeImageUrl: ''
}

const mutations = {
  setPageLoaded (state) {
    state.pageLoaded = true
  },

  setCountry (state, object) {
    state.country = object
  },

  setBannerImageUrl (state, string) {
    state.bannerImageUrl = string
  },

  setBannerImageMobileWebUrl (state, string) {
    state.bannerImageMobileWebUrl = string
  },

  setPoints (state, array) {
    state.points = array
  },

  setMembership (state, array) {
    state.membership = array
  },

  setFaqs (state, array) {
    state.faqs = array
  },

  setRewardsTitle (state, string) {
    state.rewardsTitle = string
  },

  setRewardsDescription (state, string) {
    state.rewardsDescription = string
  },

  setGiftsTitle (state, string) {
    state.giftsTitle = string
  },

  setGiftsDescription (state, string) {
    state.giftsDescription = string
  },

  setPointsTitle (state, string) {
    state.pointsTitle = string
  },

  setPointsDescription (state, string) {
    state.pointsDescription = string
  },

  setGiftsBirthdayImageUrl (state, string) {
    state.giftsBirthdayImageUrl = string
  },

  setGiftsTierUpgradeImageUrl (state, string) {
    state.giftsTierUpgradeImageUrl = string
  }
}

const actions = {
  async fetchPage ({ commit, state }, args = {}) {
    try {
      const { data, included } = await beautyPassApi.fetchPage()
      commit('setPageLoaded')
      commit('setCountry', included.find(item => item.type === 'beauty-pass-page-country'))

      commit('setPoints', included.filter(item => item.type === 'accumulate-points-bullet'))
      commit('setMembership', included.filter(item => item.type === 'membership-level-perk'))
      commit('setFaqs', included.filter(item => item.type === 'faq'))

      commit('setRewardsTitle', data.attributes['bp-rewards-title'])
      commit('setRewardsDescription', data.attributes['bp-rewards-description'])
      commit('setGiftsTitle', data.attributes['gifts-and-service-title'])
      commit('setGiftsDescription', data.attributes['gifts-and-service-description'])
      commit('setPointsTitle', data.attributes['accumulate-points-title'])
      commit('setPointsDescription', data.attributes['accumulate-points-description'])

      commit('setBannerImageUrl', state.country.attributes['banner-image-url'])
      commit('setBannerImageMobileWebUrl', state.country.attributes['banner-image-mobile-web-url'])

      if (window.screen.width >= 576) {
        commit('setGiftsBirthdayImageUrl', state.country.attributes['birthday-image-url'])
        commit('setGiftsTierUpgradeImageUrl', state.country.attributes['tier-upgrade-image-url'])
      } else {
        commit('setGiftsBirthdayImageUrl', state.country.attributes['birthday-image-mobile-web-url'])
        commit('setGiftsTierUpgradeImageUrl', state.country.attributes['tier-upgrade-image-mobile-web-url'])
      }
    } catch (error) {
      console.log('Error fetching beauty pass page details ::', error)
    }
  }
}

export default {
  state,
  mutations,
  actions
}
